import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from 'src/app/services/loader-services/loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private totalRequests = 0;
  constructor(private loadingService: LoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has('skip_loading')) {
      const modifiedRequest = request.clone({
        headers: request.headers.delete('skip_loading')
      });
      return next.handle(modifiedRequest);
    }

    if (request.headers.has('manual_loading')) {
      const modifiedRequest = request.clone({
        headers: request.headers.delete('manual_loading')
      });
      // Show loading but don't increment counter. it will be manually controlled
      this.loadingService.setLoading(true);
      return next.handle(modifiedRequest);
    }

    this.totalRequests++;
    this.loadingService.setLoading(true);
    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.loadingService.setLoading(false);
        }
      })
    );
  }
}
